export const formatUSD = (value: string | undefined): string => {
  if (!value) {
    return '';
  }

  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(value));
};
